<template>
  <div style="min-height: 90px">
    <div
      v-loading="isLoading"
      element-loading-spinner="popover-spinner"
      element-loading-background="rgba(255, 255, 255)">
    </div>
    <slot v-if="!isLoading"></slot>
  </div>
</template>

<script>
export default {
  name: 'PopoverContainer',
  components: {},
  props: {
    loadingStatus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  watch: {
    loadingStatus: function (newValue) {
      if (newValue === false) {
        return setTimeout(() => {
          this.isLoading = newValue
        }, 300)
      }

      this.isLoading = newValue
    }
  },
  methods: {}
}
</script>
